import styled from "styled-components";

export { Wrapper } from "_/components/text-field/styled";

export const TextArea = styled.textarea`
  background-color: transparent;
  border: none;
  color: inherit;
  width: 100%;
  padding: 0;
  resize: vertical;
  min-height: 4.5em;
  font-family: inherit;
  font-size: inherit;
  color-scheme: ${(p) => p.theme.input.colorScheme};
`;
